module.exports = ".m-login.m-login--1 .m-login__wrapper {\n  overflow: hidden;\n  padding: 10% 1rem 2rem 1rem; }\n\n.password-condition {\n  border: 2px solid #1B315C;\n  border-radius: 10px;\n  padding: 1rem;\n  margin-top: 2rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/authentication/templates/reset-password/reset-password.component.scss
// module id = ./src/app/pages/authentication/templates/reset-password/reset-password.component.scss
// module chunks = main